import axios from '@axios'
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
    device_tags: [],
    idNotification: "",
    url: "",
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(service_orders => ({
        value: service_orders.id,
        label: service_orders.name,
      }))
    },
    getDeviceTags(state) {
      return state.device_tags;
    },
    getIdNotification(state) {
      return state.idNotification;
    },
    getUrl(state) {
      return state.url;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setDeviceTags(state, value) {
      state.device_tags = value;
    },
    setIdNotification(state, value) {
      state.idNotification = value;
    },
    setUrl(state, value) {
      state.url = value;
    },
  },
  actions: {
    async importDocumentExample({commit}, params) {
      const response = await axios.get("v1/service_orders", {
        params,
        responseType: params?.action == "importDocumentExample" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }
      if (params?.action == "importDocumentExample") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        const {t} = useI18nUtils();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "Density master account",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Ordenes de servicio",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async export({commit}, params) {
      const response = await axios.get("v1/service_orders", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        const {t} = useI18nUtils();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "Density master account",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Ordenes de servicio",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async getAll({commit}, params) {
      const {data} = await axios.get('v1/service_orders', {params})

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const {data} = await axios.post('v1/service_orders', params)

      return data
    },
    async edit(_, {id, params}) {
      const {data} = await axios.put(`v1/service_orders/${id}`, params)

      return data
    },
    async delete(_, id) {
      const {data} = await axios.delete(`v1/service_orders/${id}`)

      return data
    },
    async editStatus(_, {id, params}) {
      const {data} = await axios.put(`v1/service_orders_status_update/${id}`, params)

      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
